// @flow

import styled from "styled-components";
import buildFDRColor from "@fdr/static-ui/ColorPalette";

const FooterNav = styled.nav`
  display: flex;
  min-height: 48px;
  background-color: ${buildFDRColor("white", "100")};
  box-shadow: 0 -1px 0 0 ${buildFDRColor("grey", "200")};
  justify-content: space-between;

  & > a,
  button {
    flex: 0 0 20%;
  }
`;

export default FooterNav;
